/* eslint-disable no-param-reassign */
import _ from 'lodash';
import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useRouteMatch } from 'react-router';
import { formActions } from '../../../Actions';
import GeneralDetails from './GeneralDetails';
import { ViewPageHeader } from '../../../Components/Headers';
import {
	StyledTabs,
	StyledTab,
	TabPanel,
} from '../../../Components/StyledTabs';
import { history, isEmpty } from '../../../Helpers';
import cookingRecipeConfig from './cookingProduct.config';
import CookingProductConfigSubSection from './CookingProductConfigSubSection';

const TABS = ['GENERAL DETAILS'];

const CookingRecipeViewPage = (props) => {
	const { fetchProductRecipe, data, breadcrumbs } = props;

	const [state, setState] = useState({
		activeTab: 0,
		fields: _.cloneDeep(cookingRecipeConfig.initialState.fields),
	});

	const { id } = useRouteMatch().params;

	useEffect(() => {
		fetchProductRecipe({
			entity: 'COOKING_PRODUCT_CONFIG',
			req: {
				params: {
					id,
				},
			},
			method: 'VIEW',
		});
	}, []);
	useEffect(() => {
		if (!isEmpty(data)) {
			setState(cookingRecipeConfig.deserializer(state, data));
		}
	}, [data]);

	const { activeTab, fields } = state;

	const handleTabChange = (event, tab) => {
		setState({
			...state,
			activeTab: tab,
		});
	};

	const renderInfo = (idx) => {
		switch (idx) {
			case 0:
				return (
					<fieldset disabled className='form-fieldset'>
						<GeneralDetails fields={fields} />
						<CookingProductConfigSubSection
							fields={fields}
							isDisabled
						/>
					</fieldset>
				);
			default:
				return <></>;
		}
	};

	const { url } = useRouteMatch();

	const redirectToEdit = () => {
		const splitURL = url.split('/view');
		splitURL.splice(1, 0, '/edit');
		const newURL = splitURL.join('');
		history.push(newURL);
	};

	return (
		<div className='root'>
			<ViewPageHeader
				heading='View Product Cooking Config'
				handleEdit={redirectToEdit}
				showDelete={false}
				breadcrumbs={[
					...breadcrumbs,
					{
						link: '',
						name: `View ${state.fields.productName}`,
					},
				]}
				showBreadcrumbs
			/>
			<StyledTabs value={activeTab} onChange={handleTabChange}>
				{TABS.map((tab) => {
					return <StyledTab label={tab} />;
				})}
			</StyledTabs>
			{TABS.map((tab, idx) => {
				return (
					<TabPanel value={activeTab} index={idx}>
						{renderInfo(idx)}
					</TabPanel>
				);
			})}
		</div>
	);
};

const mapStateToProps = (state) => {
	const data = state.form.COOKING_PRODUCT_CONFIG.data.VIEW;
	return {
		data,
	};
};

const mapDispatchToProps = {
	fetchProductRecipe: formActions.gateway,
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(CookingRecipeViewPage);
